<template>
  <v-autocomplete
    ref="controlFocoSelectLocalidad"
    label="Localidad*"
    v-model="itemActivo.Id_Localidad"
    :items="items"
    item-value="Id_Localidad"
    item-text="Nombre"
    :rules="rules"
    :readonly="readonly"
    :search-input.sync="palabraBuscada"
    :loading="loading"
    clearable
    auto-select-first
    @change="buscar"
    @keyup.enter="listar"
    @click:clear="inicializar"
    @click:append="listar"
  >
    <template v-slot:no-data>
      <v-icon small>info</v-icon>
      <small>
        Ingrese el texto a buscar y presione
        <strong>ENTER</strong>
      </small>
    </template>
    <template v-slot:progress>
      <v-progress-circular color="blue" indeterminate></v-progress-circular>
    </template>
  </v-autocomplete>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
import { eventBus } from "@/main";
export default {
  name: "SelectLocalidad",
  props: {
    model: Number,
    rules: {},
    readonly: Boolean
  },
  data() {
    return {
      rutaApi: "Localidad/",
      itemActivo: {
        Id_Localidad: 0
      },
      items: [],
      palabraBuscada: "",
      loading: false
    };
  },
  watch: {
    model(valor) {
      if (valor && valor != this.itemActivo.Id_Localidad) this.cargar(valor);
    }
  },
  created() {
    eventBus.$on("inicializarSelectLocalidad", this.inicializar);
    eventBus.$on("setearFocoSelectLocalidad", this.setearFoco);
  },
  beforeDestroy() {
    eventBus.$off("inicializarSelectLocalidad", this.inicializar);
    eventBus.$off("setearFocoSelectLocalidad", this.setearFoco);
  },
  methods: {
    inicializar() {
      this.loading = true;
      this.itemActivo = Object.assign({}, this.itemVacio);
      this.items = [];
      this.palabraBuscada = "";
      this.loading = false;
    },
    cargar(valor) {
      if (valor) {
        this.loading = true;
        HttpHelper.get(this.rutaApi, {
          id: valor
        })
          .then(response => {
            this.items.push(response.data);
            this.seleccionarItem(this.items[0]);
            this.loading = false;
          })
          .catch(error => {
            return Promise.reject(error);
          });
      }
    },
    listar() {
      if (this.palabraBuscada && this.palabraBuscada.length > 0) {
        this.loading = true;
        HttpHelper.get(this.rutaApi + "ListarSelect", {
          palabra: this.palabraBuscada
        })
          .then(response => {
            this.items = response.data;
            if (this.items.length == 1) this.seleccionarItem(this.items[0]);
            this.loading = false;
          })
          .catch(error => {
            return Promise.reject(error);
          });
      }
    },
    buscar(id) {
      if (id) {
        var ind = this.items.findIndex(x => x.Id_Localidad == id);
        this.seleccionarItem(this.items[ind]);
      } else this.seleccionarItem(this.itemVacio);
    },
    seleccionarItem(item) {
      this.itemActivo = item;
      this.$emit("seleccionarItem", this.itemActivo);
    },
    setearFoco() {
      this.$refs.controlFocoSelectLocalidad.focus();
    }
  }
};
</script>
